export enum BookingSource {
    NADA = 'J. D. Power / NADA Guides',
    LIKE_INVOICE = 'No Bookout Amount Available',
}

export function isLastYearOrNewer(year?: number) {
    const currentYear = new Date().getFullYear()
    const isValid = year && year >= currentYear - 1 && year <= currentYear + 1

    return Boolean(isValid)
}

export function isLikeInvoiceBookingSource(bookingSource?: string) {
    return bookingSource === BookingSource.LIKE_INVOICE
}

export function isLikeInvoice(year: number, bookingSource?: string) {
    return isLastYearOrNewer(year) && isLikeInvoiceBookingSource(bookingSource)
}
